"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _CoreProps = require("../utilities/CoreProps");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const HorizontalRule = props => {
  const inlineStyle = {
    width: '100%',
    borderStyle: 'solid',
    height: '0'
  };
  if (props.color) {
    inlineStyle.color = props.color;
    inlineStyle.backGroundColor = props.color;
    inlineStyle.borderColor = props.color;
  }
  if (props.thickness) {
    inlineStyle.borderWidth = props.thickness;
  }
  if (props.size) {
    inlineStyle.borderWidth = props.size;
  }
  if (props.marginTop) {
    inlineStyle.marginTop = props.marginTop;
  }
  if (props.marginBottom) {
    inlineStyle.marginBottom = props.marginBottom;
  }
  return /*#__PURE__*/_react.default.createElement("hr", {
    className: (0, _classnames.default)('horizontal-rule is-fullwidth', props.className) || undefined,
    style: inlineStyle
  });
};
HorizontalRule.propTypes = {
  className: _propTypes.default.string,
  color: _propTypes.default.string,
  thickness: _propTypes.default.string,
  size: _propTypes.default.string,
  marginTop: _propTypes.default.string,
  marginBottom: _propTypes.default.string
};
var _default = exports.default = (0, _CoreProps.withUiProps)(HorizontalRule);
//# sourceMappingURL=HorizontalRule.js.map